import fetch from 'cross-fetch'
import Axios from 'axios';
import { browserHistory } from 'react-router';
import { deleteRequest, getRequest, postRequest, putRequest } from '../../utils/apiUtils';
var request = require('request');

export const RECEIVE_PERIODICALS='RECEIVE_PERIODICALS'
export const DELETE_PERIODICAL='DELETE_PERIODICAL'
export const CREATE_PERIODICAL='CREATE_PERIODICAL'
export const RECEIVE_PERIODICAL_DETAILS='RECEIVE_PERIODICAL_DETAILS'
export const UPDATE_PERIODICAL='UPDATE_PERIODICAL'
export const CHECK_PERIODICAL='CHECK_PERIODICAL'
export const RECEIVE_PERIODICAL_REPORT='RECEIVE_PERIODICAL_REPORT'
export const SHOW_DOWNLOAD_BTN='SHOW_DOWNLOAD_BTN'
export const SHOW_WARNING='SHOW_WARNING'


/* fetch periodical list */
// const header={"device-type": "AML9327483","token-id":"aGlyZW5AbWFqZXN0aWNzZXJ2aWNlc2dyb3VwLmNvbS5hdTpoaXJlbjoyNTEx"};

function fetchPeriodicals() {
  return async dispatch => {
      return await getRequest({ url: '/api/managed_periodicals'})
      .then(response => {
          console.log(response.data);
        if(response.data.result.length>0)
        {
          dispatch(requestPeriodicals(response.data.result))
        }
        else
        {
          dispatch(requestPeriodicals([]))
        }
      })
      .catch(error => {
        if (error.response) 
        {
          if(error.response.status===403)
          {
            browserHistory.push('/');
            window.location.reload(); 
          }
          else
          {
            console.log(error);
          }
        }
      });
  }
}


function deletePeridical(id) {
    return async dispatch => {
        return await deleteRequest({ url: '/api/managed_periodicals/'+id})
        .then(response => {
            dispatch(removePeridical(response.data))
          
        })
        .catch(error => {
          if (error.response) 
						{
							if(error.response.status===403)
							{
								browserHistory.push('/');
								window.location.reload(); 
							}
							else
							{
								console.log(error);
							}
						}
        });
    }
  }

  function addPeridicals(post) {
    return async dispatch => {
        return await postRequest({ url: '/api/managed_periodicals', payload: post})
        .then(response => {
            dispatch(createNewPeridical(response.data))
        })
        .catch(error => {
          if (error.response) 
						{
							if(error.response.status===403)
							{
								browserHistory.push('/');
								window.location.reload(); 
							}
							else
							{
								console.log(error);
							}
						}
        });
    }
  }

  function getPeridicalDetails(id) {
    return async dispatch => {
        return await getRequest({ url: '/api/managed_periodicals/'+id})
        .then(response => {
            dispatch(peridicalDetails(response.data.result))
        })
        .catch(error => {
          if (error.response) 
						{
							if(error.response.status===403)
							{
								browserHistory.push('/');
								window.location.reload(); 
							}
							else
							{
								console.log(error);
							}
						}
        });
    }
  }

  function updatePeridical(post) {
    return async dispatch => {
        return await putRequest({ url: '/api/managed_periodicals', payload: post})
        .then(response => {
            dispatch(editPeriodical(response.data))
        })
        .catch(error => {
          if (error.response) 
						{
							if(error.response.status===403)
							{
								browserHistory.push('/');
								window.location.reload(); 
							}
							else
							{
								console.log(error);
							}
						}
        });
    }
  }

function requestPeriodicals(response) {
  return {
    type: RECEIVE_PERIODICALS,
    periodicals_data: response
  }
}

function removePeridical(response) {
    return {
      type: DELETE_PERIODICAL,
      periodical_delete_data: response
    }
  }

  function createNewPeridical(response) {
    return {
      type: CREATE_PERIODICAL,
      periodical_delete_data: response
    }
  }

  function peridicalDetails(response) {
    return {
      type: RECEIVE_PERIODICAL_DETAILS,
      periodical_data: response
    }
  }

  function editPeriodical(response) {
    return {
      type: UPDATE_PERIODICAL,
      periodical_delete_data: response
    }
  }
  


export function fetchPeriodicalsList() {
  return (dispatch) => {
      return dispatch(fetchPeriodicals())
  }
}

export function removePeridicalData(id) {
    return (dispatch) => {
        return dispatch(deletePeridical(id))
    }
  }



  export function CreatePeridical(post) {
    console.log(post);
    return (dispatch) => {
        return dispatch(addPeridicals(post))
    }
  }

  export function getPeridical(id) {
    return (dispatch) => {
        return dispatch(getPeridicalDetails(id))
    }
  }

  export function updatePeridicalData(post){
    return (dispatch)=>{
      return dispatch(updatePeridical(post));
    }
  }


  function requestCheck(post) {
    return async dispatch => {
        return await postRequest({ url: '/api/check_exist_periodical', payload: {periodical_name:post}})
        .then(response => {
            dispatch(checkPeriodical(response.data))
        })
        .catch(error => {
          if (error.response) 
						{
							if(error.response.status===403)
							{
								browserHistory.push('/');
								window.location.reload(); 
							}
							else
							{
								console.log(error);
							}
						}
        });
    }
  }

  function checkPeriodical(response) {
    return {
      type: CHECK_PERIODICAL,
      check_periodical: response
    }
  }

  export function checkExistPeriodical(post){
    return (dispatch)=>{
      return dispatch(requestCheck(post));
    }
  }

  function receivePeriodicalReport(response) {
    return {
      type: RECEIVE_PERIODICAL_REPORT,
      periodical_report_data: response
    }
  }

  export function needToShowDownloadBtn(val) {
    return {
      type: SHOW_DOWNLOAD_BTN,
      showDownloadBtn: val
    }
  }

  export function needToShowWaring(val) {
    return {
      type: SHOW_WARNING,
      showWarning: val
    }
  }

  function getPeridicalReportDetails(post) {
    const{year,facility_id,status}=post
    return async dispatch => {
        return await getRequest({ url: '/api/facilitywise_periodical_year_report/'+year+'/'+facility_id+'/'+status})
        .then(response => {

          if(response.data.result.report_path && response.data.result.report_path !== ""){

            dispatch(receivePeriodicalReport(response.data.result))
            dispatch(needToShowDownloadBtn(true))
            dispatch(needToShowWaring(false))

          } else {
            dispatch(receivePeriodicalReport(response.data.result))
            dispatch(needToShowDownloadBtn(false))
            dispatch(needToShowWaring(true))
          }
        })
        .catch(error => {
          if (error.response) 
						{
							if(error.response.status===403)
							{
								browserHistory.push('/');
								window.location.reload(); 
							}
							else
							{
								console.log(error);
							}
						}
        });
    }
  }

  export function receivePeriodicalReportData(post){
    return (dispatch)=>{
      return dispatch(getPeridicalReportDetails(post));
    }
  }



// WEBPACK FOOTER //
// ./src/shared/actions/periodicals_action.js